import { useEffect } from 'react'
import { useKeycloak } from '@web/modules/core'
import { NotificationService } from '@web/notifications/NotificationService'
import { useNavigate } from 'react-router'

const Logout = () => {
  const { instance: kcInstance } = useKeycloak()
  const navigate = useNavigate()

  useEffect(() => {
    NotificationService.endNotificationService().then(() => {
      kcInstance?.logout()
    })
  }, [kcInstance, navigate])

  return null
}

export default Logout
